import { z } from 'zod';
export const ADMIN_PASSWORD_MIN_LENGTH = 8;
export const ADMIN_PASSWORD_MAX_LENGTH = 1024;
export const apiErrorSchema = z.object({
    accepted: z.literal(false).optional(),
    code: z.string(),
    message: z.string(),
    retryable: z.boolean(),
    requestId: z.string(),
    details: z.unknown().optional(),
});
export const projectEnvironmentSchema = z.object({
    publicId: z.string().uuid(),
    projectPublicId: z.string().uuid(),
    projectSlug: z.string(),
    slug: z.string(),
    displayName: z.string(),
    enabled: z.boolean(),
});
//# sourceMappingURL=platform.js.map